export const lightSupplierEndpoint = 'provider';

export interface LightSupplier {
  name: string;
};



// WEBPACK FOOTER //
// ./src/app/models/light-supplier.ts